import { HStack } from '@genial/components';
import { Color } from '@genial/design-tokens';
import React, { useEffect, useRef } from 'react';
import { Animated, Easing } from 'react-native';

const DOT_SIZE = 6;
const DOT_COUNT = 3;

export const RequestSubmitLoadingDots: React.FC = () => {
  const animations = useRef(
    Array.from({ length: DOT_COUNT }, () => new Animated.Value(0.35))
  ).current;

  useEffect(() => {
    const loops = animations.map((anim, index) =>
      Animated.loop(
        Animated.sequence([
          Animated.delay(index * 150),
          Animated.timing(anim, {
            toValue: 1,
            duration: 300,
            easing: Easing.inOut(Easing.ease),
            useNativeDriver: true,
          }),
          Animated.timing(anim, {
            toValue: 0.35,
            duration: 300,
            easing: Easing.inOut(Easing.ease),
            useNativeDriver: true,
          }),
        ])
      )
    );

    loops.forEach((loop) => loop.start());
    return () => loops.forEach((loop) => loop.stop());
  }, [animations]);

  return (
    <HStack
      space="inline.quarck"
      alignItems="center"
      justifyContent="center"
      testID="report-generator-request-submit-loading-dots">
      {animations.map((anim, index) => (
        <Animated.View
          key={`request-submit-dot-${index}`}
          style={{
            width: DOT_SIZE,
            height: DOT_SIZE,
            borderRadius: DOT_SIZE / 2,
            backgroundColor: Color['neutral.white'],
            opacity: anim,
          }}
        />
      ))}
    </HStack>
  );
};
